import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_GSC_CHECK_ELIGIBILITY_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NewApplicationResponse {
  uuid: string;
}

export interface ExamLevelSeriesCoordinatorRequest {
  examLevelUuid: string;
  examSeriesUuid: string;
  groupScType: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: NewApplicationResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateNewGSCApplication = ({ onSuccess, onError }: Input = {}) => {
  const postCreateNewGSCApplication = async (reqBody: ExamLevelSeriesCoordinatorRequest) => {
    const res = await axiosClient.post<NewApplicationResponse>(
      POST_GSC_CHECK_ELIGIBILITY_URL,
      reqBody
    );
    return res.data;
  };

  return useCustomMutation(postCreateNewGSCApplication, {
    onSuccess,
    onError,
  });
};
